import * as React from 'react';
import { CheckboxButtonGroup, InlineText2, TOptionValue } from '@cian/ui-kit';
import { TControlOptions } from '@cian/ui-kit/types/controls/IControlGroupProps';
import * as styles from './CheckboxGroup.css';

interface IRoomsCheckboxProps {
  title: string;
  value: TOptionValue[];
  options: TControlOptions;
  onChange: (event: React.SyntheticEvent, value: TOptionValue[]) => void;
}

export function CheckboxGroup({ title, value, options, onChange }: IRoomsCheckboxProps) {
  return (
    <>
      <InlineText2>{title}</InlineText2>
      <div className={styles['group']}>
        <CheckboxButtonGroup options={options} value={value} onChange={onChange} spliced={false} />
      </div>
    </>
  );
}
